export enum State {
  COMPLETED = 'COMPLETED',
  SEND_ENGINEER = 'SEND TO ENGINEER',
  IN_PROGRESS = 'IN PROGRESS',
  EMPTY = 'EMPTY',
}
